import { render, staticRenderFns } from "./ansTstStart.vue?vue&type=template&id=3cd4facf&scoped=true"
import script from "./ansTstStart.vue?vue&type=script&lang=js"
export * from "./ansTstStart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd4facf",
  null
  
)

export default component.exports